import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Dispatch, iRootState } from '../../../store';
import { IId } from '../../../models/types';
import { Select } from 'antd';

const useStyles = makeStyles(() => ({
  select: {
    width: '400px',
    height: '44px',
    borderRadius: '8px',
    dropShadow: '(0px 4px 16px rgba(0, 0, 0, 0.08))',
    '&:host .mts-input__control-container': {
      borderRadius: '8px'
    }
  }
}));

interface IOption {
  id: IId;
  name: string;
}

const mapState = (state: iRootState) => ({
  maps: state.infrastructureMaps.list,
  map: state.infrastructureMap.map,
  office: state.infrastructureOffices.item
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    getMap: d.infrastructureMap.getMap,
    getMaps: d.infrastructureMaps.getMaps,
    resetMaps: d.infrastructureMaps.resetMaps
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

type IProps = connectedProps;

const Maps: FC<IProps> = ({ getMap, getMaps, resetMaps, maps, map, office }) => {
  const { id: mapId } = map;

  const classes = useStyles();

  useEffect(() => {
    if (office) {
      getMaps(office.id);
    }
  }, [office]);

  useEffect(() => {
    return () => {
      resetMaps();
    };
  }, []);

  useEffect(() => {
    // Если более одного плана и план не выбран, выбираем "Все планы"
    if (maps.length > 1 && !mapId) {
      onChange('all');
      return;
    }
    // Если один план и не выбран план или выбран "Все планы", выбираем единственный план
    if (maps.length === 1 && (!mapId || mapId === 'all')) {
      onChange(maps[0].id);
    }
  }, [maps, mapId]);

  const onChange = (event: any) => {
    localStorage.setItem('mapId', event);
    // Сохраняем ID офиса при выборе "Все планы"
    if (office && office.id) {
      localStorage.setItem('officeId', String(office.id));
    }
    getMap(event);
  };

  const renderOptions = (options: IOption[]) => {
    const mapOptions = options.map(({ id, name }) => ({ value: id, label: name }));
    // Сортируем опции
    mapOptions.sort((a, b) =>
      (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())
    );
    // Добавляем опцию "Все планы" в начало только если планов больше одного
    if (options.length > 1) {
      const allOption = { value: 'all', label: 'Все планы' };
      return [allOption, ...mapOptions];
    }
    return mapOptions;
  };

  return (
    <Grid item>
      <Select
        size={'large'}
        value={mapId as string}
        showSearch
        optionFilterProp="label"
        className={classes.select}
        onChange={onChange}
        options={renderOptions(maps)}
      />
    </Grid>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(Maps);
